import type { FeatureCollection } from 'geojson';
import { pointAreaHa } from './map-point.models';

export function whispGeometryKey(site: FeatureCollection): string {
  return JSON.stringify(
    site.features.map((feature) =>
      feature.geometry?.type === 'Point' ? [feature.geometry, pointAreaHa(feature.properties)] : [feature.geometry]
    )
  );
}
